export const handleRemoveRow = (target, data, updateData) => {
  const updatedRows = data.filter((_, i) => i !== target);
  updateData(updatedRows);
};

export const handleSimpleChange = (index, field, value, data, updateData) => {
  let sanitizedValue = value;
  if (field === "amount") {
    sanitizedValue = value.reduce((sum, num) => sum + num, 0);
  } else if (field === "name") sanitizedValue = value.slice(0, 60);
  else if (field === "reference") sanitizedValue = value.slice(0, 10);

  const updatedRows = data.map((row, i) => {
    if (i === index && field !== "amount") {
      return {
        ...row,
        [field]: sanitizedValue,
      };
    } else if (i === index && field === "amount") {
      return {
        ...row,
        [field]: sanitizedValue,
        ["historyAmount"]: value,
      };
    }

    return row;
  });
  updateData(updatedRows);
};

export const handleAmountFocus = (data, index, updateData) => {
  const row = data[index];
  if (row.historyAmount && row.historyAmount.length > 1) {
    const expression = row.historyAmount
      .map((num, idx) => (num >= 0 && idx > 0 ? `+${num}` : num))
      .join("");
    const updatedRows = data.map((r, i) =>
      i === index ? { ...r, amount: expression } : r
    );
    updateData(updatedRows);
  }
};

export const handleAmountBlur = (data, index, updateData) => {
  const row = data[index];
  if (row.amount) {
    try {
      const amountStr = row.amount;

      const historyArray = amountStr
        .match(/[-+]?\d+(\.\d+)?/g)
        .map((num) => parseFloat(num));

      const sumAmount = historyArray.reduce((sum, num) => sum + num, 0);

      const updatedRows = data.map((r, i) => {
        if (i === index) {
          return {
            ...r,
            amount: sumAmount.toString(),
            historyAmount: historyArray,
          };
        }
        return r;
      });
      updateData(updatedRows);
    } catch (error) {
      console.error("[handleAmountBlur] Error processing amount:", error);
    }
  }
};

export const handleKeyDownIfEnter = (
  event,
  data,
  index,
  updateData,
  callback
) => {
  if (event.key === "Enter") {
    callback(data, index, updateData);
  }
};
